import React, { useState } from 'react'
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CustomMenu from '../../../../components/Menu';
import Active from './Active';
import ImpersonateUser from './ImpersonateUser';
import DeleteUser from './DeleteUser';
import ResendInvite from './ResendInvite';

function Action({ params }) {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    
  return (
    <>
      <MoreVertIcon
        className="user-management-action-icon cursor-pointer"
        onClick={handleClick}
      />
      <CustomMenu
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
      >
        {params.row.active && <ImpersonateUser params={params} />}
        <Active isActive={params.row.active} id={params.row.user_id} />
        {params.row.active && <ResendInvite params={params} />}
        {params.row.active && <DeleteUser params={params} />}
        {/* <CustomMenuItem>Delete user</CustomMenuItem> */}
      </CustomMenu>
    </>
  );
}

export default Action